import type { Outline } from "../math/samplePath";

/** Closed cubic Bézier heart, clockwise in SVG's y-down coordinates. */
export const heart: Outline = [
  {
    from: { x: 0, y: -0.52 },
    c1: { x: 0.3, y: -1.08 },
    c2: { x: 1, y: -1.06 },
    to: { x: 1, y: -0.36 },
  },
  {
    from: { x: 1, y: -0.36 },
    c1: { x: 1, y: 0.17 },
    c2: { x: 0.45, y: 0.66 },
    to: { x: 0, y: 1.04 },
  },
  {
    from: { x: 0, y: 1.04 },
    c1: { x: -0.45, y: 0.66 },
    c2: { x: -1, y: 0.17 },
    to: { x: -1, y: -0.36 },
  },
  {
    from: { x: -1, y: -0.36 },
    c1: { x: -1, y: -1.06 },
    c2: { x: -0.3, y: -1.08 },
    to: { x: 0, y: -0.52 },
  },
];
